// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"0":"b9ee494413deae171545","794":"3cdf8c8719c20ecf6759","924":"39b5ae27a750522abf75","926":"218f1ada7eaa80035991"}[chunkId] + ".js";
};